export default {"src":"/_next/static/media/icon-fuel-efficiency.4604349d.svg","height":12,"width":13,"blurWidth":0,"blurHeight":0};